import {
  ReportDocumentData,
  ReportExpensesDateData,
  ReportExpensesRelationData,
  ReportingFiltersSchema,
  ReportPaymentData,
  ReportSalesClientData,
  ReportSalesDateData,
  ReportSalesItemData,
  ReportTaxData,
} from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type ReportingFilters = ReportingFiltersSchema;

export const getActivityReport = async (filters: ReportingFiltersSchema): Promise<ReportDocumentData[]> => {
  const response = await apiClient.post<ReportDocumentData[]>("/api/reporting/activity", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getSalesReport = async (filters: ReportingFiltersSchema): Promise<ReportDocumentData[]> => {
  const response = await apiClient.post<ReportDocumentData[]>("/api/reporting/sales", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getSalesDateReport = async (filters: ReportingFiltersSchema): Promise<ReportSalesDateData[]> => {
  const response = await apiClient.post<ReportSalesDateData[]>("/api/reporting/sales-per-date", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getSalesClientReport = async (filters: ReportingFiltersSchema): Promise<ReportSalesClientData[]> => {
  const response = await apiClient.post<ReportSalesClientData[]>("/api/reporting/sales-per-client", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getSalesItemsReport = async (filters: ReportingFiltersSchema): Promise<ReportSalesItemData[]> => {
  const response = await apiClient.post<ReportSalesItemData[]>("/api/reporting/sales-per-items", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getPaymentsReport = async (filters: ReportingFiltersSchema): Promise<ReportDocumentData[]> => {
  const response = await apiClient.post<ReportDocumentData[]>("/api/reporting/payments", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getPaymentsDateReport = async (filters: ReportingFiltersSchema): Promise<ReportPaymentData[]> => {
  const response = await apiClient.post<ReportPaymentData[]>("/api/reporting/payments-per-date", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getPaymentsRelationReport = async (filters: ReportingFiltersSchema): Promise<ReportPaymentData[]> => {
  const response = await apiClient.post<ReportPaymentData[]>("/api/reporting/payments-per-relation", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getPaymentsTypeReport = async (filters: ReportingFiltersSchema): Promise<ReportPaymentData[]> => {
  const response = await apiClient.post<ReportPaymentData[]>("/api/reporting/payments-per-type", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getExpensesReport = async (filters: ReportingFiltersSchema): Promise<ReportDocumentData[]> => {
  const response = await apiClient.post<ReportDocumentData[]>("/api/reporting/expenses", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getExpensesDateReport = async (filters: ReportingFiltersSchema): Promise<ReportExpensesDateData[]> => {
  const response = await apiClient.post<ReportExpensesDateData[]>("/api/reporting/expenses-per-date", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getExpensesRelationReport = async (
  filters: ReportingFiltersSchema,
): Promise<ReportExpensesRelationData[]> => {
  const response = await apiClient.post<ReportExpensesRelationData[]>("/api/reporting/expenses-per-relation", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getTaxReport = async (filters: ReportingFiltersSchema): Promise<ReportTaxData[]> => {
  const response = await apiClient.post<ReportTaxData[]>("/api/reporting/tax", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getTaxDesignationReport = async (filters: ReportingFiltersSchema): Promise<ReportTaxData[]> => {
  const response = await apiClient.post<ReportTaxData[]>("/api/reporting/tax-per-designation", filters, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getReportYears = async (): Promise<number[]> => {
  const response = await apiClient.get<number[]>("/api/reporting/years");
  return response.data;
};
